// hooks/useBrowser.tsx
'use client';
import { useState, useEffect } from 'react';

// Hook to safely check if code is running on the client
export function useIsClient(): boolean {
  const [isClient, setIsClient] = useState<boolean>(false);
  
  useEffect(() => {
    setIsClient(true);
  }, []);
  
  return isClient;
}

// Hook for scroll position
export function useScrollPosition(): { x: number; y: number } {
  const isClient = useIsClient();
  const [scrollPosition, setScrollPosition] = useState<{ x: number; y: number }>({ 
    x: 0, 
    y: 0 
  });
  
  useEffect(() => {
    if (!isClient) return;
    
    const handleScroll = () => {
      setScrollPosition({
        x: window.scrollX,
        y: window.scrollY
      });
    };
    
    // Set initial position
    handleScroll();
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isClient]);
  
  return scrollPosition;
}

// Hook for document class manipulation
export function useBodyClass(className: string, condition: boolean): void {
  const isClient = useIsClient();
  
  useEffect(() => {
    if (!isClient) return;
    
    if (condition) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
    
    return () => {
      document.body.classList.remove(className);
    };
  }, [className, condition, isClient]);
}